import { ClientLambdaApi } from '@/api-client.js'

const checkClientTermsAcceptance = async () => {
  const response = await ClientLambdaApi.get('/admin/client-terms/check')
  if (response.status !== 200) {
    throw new Error('Error al verificar la aceptación de términos')
  }
  return response.data
}

const acceptClientTerms = async (termsVersion = '1.0') => {
  const response = await ClientLambdaApi.post('/admin/client-terms', {
    terms_version: termsVersion
  })
  if (response.status !== 200 && response.status !== 201) {
    throw new Error('Error al aceptar los términos del servicio')
  }
  return response.data
}

export { checkClientTermsAcceptance, acceptClientTerms }



// WEBPACK FOOTER //
// ./src/app/authentication/ClientTermsServices.js